export default __webpack_public_path__ + "static/media/503.27396006.svg";